import React from "react";

// Modifier clicks and non-primary buttons are left to the browser so an anchor keeps its native
// "open in new tab" behaviours; only an unmodified left click is treated as an in-app action.
export function isPlainLeftClick(event: React.MouseEvent | MouseEvent) {
    return event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
}
